var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarthEu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#earth-eu_svg__clip0_10799_12396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.26l.518 1.595h1.676l-1.356.985.518 1.595L16 9.449l-1.356.986.518-1.595-1.356-.985h1.676L16 6.261zM9.113 9.114l1.494.76 1.185-1.185-.262 1.656 1.494.761-1.656.262-.262 1.656-.761-1.493-1.656.262 1.186-1.185-.762-1.494zM6.26 16l1.595-.518v-1.676l.986 1.356 1.594-.518L9.449 16l.986 1.356-1.595-.518-.985 1.356v-1.676L6.261 16zM9.113 22.887l.761-1.494-1.185-1.185 1.656.262.76-1.493.263 1.655 1.656.262-1.494.762.262 1.655-1.185-1.185-1.494.76zM16 25.74l-.518-1.595h-1.676l1.356-.985-.518-1.595 1.356.986 1.356-.986-.518 1.595 1.356.985h-1.676L16 25.739zM22.887 22.887l-1.494-.761-1.185 1.185.262-1.655-1.494-.761 1.656-.263.262-1.655.761 1.493 1.656-.262-1.185 1.185.76 1.494zM25.74 16l-1.595.518v1.676l-.985-1.356-1.595.518.986-1.356-.986-1.356 1.595.518.985-1.356v1.676l1.594.518zM22.887 9.114l-.761 1.493 1.185 1.186-1.656-.263-.76 1.494-.263-1.656-1.656-.262 1.494-.761-.262-1.656 1.185 1.186 1.494-.761z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "earth-eu_svg__clip0_10799_12396"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgEarthEu;